<template>
    <v-row v-if="!$store.getters.progress" class="ma-0">
        <v-col cols="12" class="pa-0">
			<v-card class="pa-0 round-card background-2">
				<v-card-title class="pa-2">
					<div>
						<p class="pl-2 pl-xl-3">Commissioni</p>
					</div>
                    <v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>

                <v-container class="pt-4" fluid>
					<v-row class="ma-0 px-4 pb-2" v-if="loaded">
                        <v-col class="col-12 col-sm-4 col-md-4 col-lg-4 pr-3">
                            <gmh-date-picker
                                v-model="model['from']"
                                label="Dal"
                                :clearable="false"
                            ></gmh-date-picker>
                        </v-col>
                        
                        <v-col class="col-12 col-sm-4 col-md-4 col-lg-4 px-3">
                            <gmh-date-picker
                                v-model="model['to']"
                                label="Al"
                                :clearable="false"
                            ></gmh-date-picker>
                        </v-col>

                        <v-col class="col-12 col-sm-4 col-md-4 col-lg-4 pl-3">
                            <v-select
                                v-model="model['doctype']"
                                :items="docTypeOptions"
                                label="Tipo documento"
                                outlined
                                dense
                                item-text="text"
                                item-value="value"
                            ></v-select>
                        </v-col>
					</v-row>		
					<v-row>
						<v-divider></v-divider>
					</v-row>

                    <v-row v-show="loaded">
						<v-data-table class="background-2 w100p"
							:items="items"
							:headers="headers"
							hide-default-footer
							disable-pagination
							:mobile-breakpoint="0">
							<template v-slot:item="{ item }">
								<tr class="cursor-pointer">
									<template v-for="(header, h) in headers">
										<td v-if="header.value == 'total_commission'" :key="'commission-' + h">
											{{ item[header.value] | currency }}
										</td>
										<td v-else :key="'other-' + h">
											{{ item[header.value] }}
										</td>
									</template>
								</tr>
							</template>
							<!-- <template v-slot:body.append>
								<tr>
									<td v-for="(header, h) in headers" :key="h">
										<strong class="fs14i" v-if="h == 0">Totale</strong>
										<strong class="fs14i" v-else>{{ calcTotal() | currency }}</strong>
									</td>
								</tr>
							</template> -->
						</v-data-table>
					</v-row>
				</v-container>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>

export default {
	name: 'commissions',
	props: {
	},

	data() {
		return {
            headers: [
                {
                    'text': 'Agente',
                    'value': 'agent',
                },
                {
                    'text': 'Commissione',
                    'value': 'total_commission',
                },
            ],
			model: {
                'from': moment().startOf('month').format('YYYY-MM-DD'),
                'to': moment().endOf('month').format('YYYY-MM-DD'),
                'doctype': 'ddt',
            },
			items: [],
			loaded: false,
            docTypeOptions: [
                {
                    text: 'Preventivi',
                    value: 'quotation'
                },
                {
                    text: 'Ordini di Vendita',
                    value: 'saleorder'
                },
                {
                    text: 'DDT',
                    value: 'ddt'
                },
                {
                    text: 'Fatture Proforma',
                    value: 'proformainvoice'
                },
                {
                    text: 'Fatture di Vendita',
                    value: 'saleinvoice'
                },
            ],
		}
	},

		
	created() {
        this.$store.commit('endProgress')
	},


	watch: {
		model: {
			handler() {
				this.getData()
			},
			deep: true,
			immediate: true,
		},
	},

	methods: {

		getData() {
			this.axios.post('commissions/', this.model).then(response => {

				this.loaded = true
                this.items = response.data.data

			}, response => {
				// error callback
			})
		},

		calcTotal() {
			return this.items.reduce((acc, data) => acc + parseFloat(data.total_commission), 0)
		},        
	},
}
</script>